import { Link } from "react-router-dom";

const testimonialData = [
  {
    name: "Marcus J.",
    role: "Sneaker Collector, London",
    rating: 5,
    text: "The Kakobuy Spreadsheet completely changed how I shop. Found verified sellers I would have never discovered on my own. Already copped three pairs of grails using these links.",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20man%20with%20short%20dark%20hair%20in%20casual%20modern%20streetwear%20attire%20against%20a%20soft%20warm%20neutral%20studio%20background%20with%20gentle%20lighting%20clean%20minimalist%20look%20friendly%20genuine%20expression&width=72&height=72&seq=avatar-marcus-v3-2026&orientation=squarish",
  },
  {
    name: "Sophie L.",
    role: "Fashion Buyer, Paris",
    rating: 5,
    text: "Honestly the best resource for Kakobuy shopping. The spreadsheet is updated so frequently that I always catch new drops before they sell out. Saved hundreds on shipping fees.",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20woman%20with%20shoulder%20length%20light%20brown%20hair%20in%20stylish%20modern%20attire%20against%20a%20soft%20warm%20neutral%20studio%20background%20with%20natural%20lighting%20clean%20minimalist%20look%20warm%20confident%20smile&width=72&height=72&seq=avatar-sophie-v3-2026&orientation=squarish",
  },
  {
    name: "David K.",
    role: "Streetwear Enthusiast, NYC",
    rating: 5,
    text: "Been using this kakobuy spreadsheet for months now. The QC photo links alone are worth it. No more guessing what you're actually getting. Real buyer protection.",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20man%20in%20his%20late%20twenties%20with%20short%20styled%20hair%20in%20urban%20casual%20attire%20against%20a%20soft%20warm%20neutral%20studio%20background%20with%20warm%20lighting%20clean%20minimalist%20look%20confident%20approachable%20expression&width=72&height=72&seq=avatar-david-v3-2026&orientation=squarish",
  },
  {
    name: "Emma R.",
    role: "Reseller, Melbourne",
    rating: 4,
    text: "Great spreadsheet for sourcing inventory. The category breakdown makes it super easy to find specific items. Would love even more designer bag listings but still fantastic.",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20woman%20with%20curly%20dark%20hair%20in%20smart%20casual%20modern%20attire%20against%20a%20soft%20warm%20neutral%20studio%20background%20with%20gentle%20lighting%20clean%20minimalist%20look%20pleasant%20genuine%20expression&width=72&height=72&seq=avatar-emma-v3-2026&orientation=squarish",
  },
  {
    name: "James T.",
    role: "First-time Kakobuy User, Toronto",
    rating: 5,
    text: "As someone new to Kakobuy, this spreadsheet was a lifesaver. The safety guide and verified seller list gave me confidence to make my first purchase. Arrived perfectly.",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20man%20with%20light%20brown%20hair%20in%20clean%20modern%20casual%20attire%20against%20a%20soft%20warm%20neutral%20studio%20background%20with%20warm%20lighting%20clean%20minimalist%20look%20genuine%20friendly%20smile&width=72&height=72&seq=avatar-james-v3-2026&orientation=squarish",
  },
  {
    name: "Olivia M.",
    role: "Luxury Shopper, Dubai",
    rating: 5,
    text: "The spreadsheet is incredibly well-organized. Found top-tier designer accessories at prices way below retail. The trusted seller badge system is genuinely helpful.",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20woman%20with%20long%20sleek%20dark%20hair%20in%20elegant%20modern%20attire%20against%20a%20soft%20warm%20neutral%20studio%20background%20with%20soft%20lighting%20clean%20minimalist%20look%20warm%20sophisticated%20smile&width=72&height=72&seq=avatar-olivia-v3-2026&orientation=squarish",
  },
];

export default function Testimonials() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="flex items-center gap-3 mb-4">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs font-semibold text-foreground-500 uppercase tracking-wider">
              Real Reviews
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3 leading-tight">
            What Buyers Say About
            <br />
            Kakobuy Spreadsheet
          </h2>
          <p className="text-sm text-foreground-600 mb-12 max-w-lg">
            Trusted by thousands of shoppers worldwide for finding verified Kakobuy products.
          </p>

          {/* Testimonial Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {testimonialData.map((t, idx) => (
              <article
                key={idx}
                className="bg-background-50 rounded-xl p-6 border border-background-200/70"
              >
                {/* Stars */}
                <div className="flex items-center gap-0.5 mb-4">
                  {Array.from({ length: 5 }).map((_, si) => (
                    <span key={si} className="w-4 h-4 flex items-center justify-center">
                      <i
                        className={`text-sm ${
                          si < t.rating ? "text-primary-500 ri-star-fill" : "text-background-300 ri-star-line"
                        }`}
                      ></i>
                    </span>
                  ))}
                </div>

                <p className="text-sm text-foreground-700 leading-relaxed mb-5">
                  &ldquo;{t.text}&rdquo;
                </p>

                <div className="flex items-center gap-3 pt-4 border-t border-background-200/70">
                  <div className="w-9 h-9 rounded-full bg-background-200 overflow-hidden flex-shrink-0">
                    <img
                      src={t.avatarUrl}
                      alt={t.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </div>
                </div>
              </article>
            ))}
          </div>

          {/* Link to Guide */}
          <div className="text-center mt-12">
            <Link
              to="/guide/how-to-use-kakobuy-spreadsheet"
              className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors"
            >
              Read More Reviews &amp; Guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}